export default __webpack_public_path__ + "static/media/Evelyn 9781408357545.8f0d9549.jpg";